import { CampaignState } from "@regal-voice/shared-types/entities";
import { clsx } from "clsx";

import styles from "./CampaignStatus.module.scss";

export function CampaignStatusTag({
    state,
    spaceAbove = false,
}: {
    state: CampaignState;
    spaceAbove?: boolean;
}): JSX.Element {
    // replace with RVStatusBadge
    return <span className={clsx(styles.statusTag, styles[state], { [styles.spaceAbove]: spaceAbove })}>{state}</span>;
}
